import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0","key":"svg-0"}],["path",{"d":"M4 12l3 -4l4 2l5 -6l4 4","key":"svg-1"}]]

/**
 * IconChartAreaLine
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hhcnQtYXJlYS1saW5lIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDE5bDQgLTZsNCAybDQgLTVsNCA0bDAgNWwtMTYgMCIgLz4KICA8cGF0aCBkPSJNNCAxMmwzIC00bDQgMmw1IC02bDQgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chart-area-line
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChartAreaLine = createReactComponent('outline', 'chart-area-line', 'ChartAreaLine', __iconNode);

export default IconChartAreaLine;